import React from 'react';
import { ConfirmModal } from '../../../../components/Modal/ConfirmModal';

export interface NavigationUnsavedChangesModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Modal para confirmar navegação quando há alterações não salvas
 */
export const NavigationUnsavedChangesModal: React.FC<NavigationUnsavedChangesModalProps> = ({
  isOpen,
  onConfirm,
  onClose,
}) => {
  return (
    <ConfirmModal
      isOpen={isOpen}
      type="warning"
      title="Alterações Não Salvas"
      message="Você tem alterações não salvas. Tem certeza que deseja navegar para outra página?"
      details="Todas as alterações feitas serão perdidas permanentemente."
      confirmText="Sim, Sair"
      cancelText="Cancelar"
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
